import React, { type FC, type PropsWithChildren } from 'react';

import { Box, Heading, Paper, Link, Container } from '@lucid/components';

import type { Lucid } from 'types/types';

const FlexiPreFooter: FC<PropsWithChildren<Lucid.Directus.Generated.Flexi_Pre_Footer>> = ({ heading, link }) => {
  if (!link || !link.final_url) {
    return null;
  }

  return (
    <Box
      css={theme => ({
        position: 'relative',
        width: '100%',
        paddingBottom: theme.space.s24,
        zIndex: theme.zIndices[1],
        marginTop: 0,
        [theme.breakpoints.bp768.min]: {
          marginTop: theme.space.s40,
        },
        '&::before': {
          [theme.breakpoints.bp768.min]: {
            content: '""',
            position: 'absolute',
            top: '50px',
            left: 0,
            width: '100%',
            height: 'calc(100% - 50px)',
            backgroundColor: theme.colors.coolGrey[0],
          },
        },
      })}
    >
      <Container as="section">
        <Paper>
          <Box
            css={{
              alignItems: 'center',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'stretch',
            }}
          >
            <Heading
              as="h2"
              css={theme => ({
                margin: 0,
                flex: '0 1 100%',
                [theme.breakpoints.bp900.min]: {
                  flex: '0 1 75%',
                },
              })}
              variant="headingXL"
            >
              {heading}
            </Heading>
            <Box
              css={theme => ({
                flex: '0 1 100%',
                marginTop: theme.space.s32,
                [theme.breakpoints.bp900.min]: {
                  flex: '0 1 25%',
                  textAlign: 'right',
                  marginTop: 0,
                },
              })}
            >
              {link && (
                <Link displayAsButton data-ga-description="nineteen-footer-card-card-link" href={link.final_url}>
                  {link.default_link_text}
                </Link>
              )}
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default FlexiPreFooter;
